import React from "react";

const CheckingEligibility = ({ isCheckingEligibilityOpen, customer }) => {
  if (!isCheckingEligibilityOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-10 backdrop-blur-sm">
      <div className="bg-white rounded-md shadow-xl w-[670px] h-[300px] flex flex-col items-center justify-center p-8">
        <div className="flex space-x-3 mb-6">
          <span
            className="w-2 h-2 bg-[#074073] rounded-full animate-bounce"
            style={{ animationDelay: "0s" }}
          ></span>
          <span
            className="w-2 h-2 bg-[#7FB8EB] rounded-full animate-bounce"
            style={{ animationDelay: "0.15s" }}
          ></span>
          <span
            className="w-2 h-2 bg-[#074073] rounded-full animate-bounce"
            style={{ animationDelay: "0.3s" }}
          ></span>
        </div>
        <div className="text-center">
          <p className="text-xl font-semibold text-gray-900 mb-3">
            Checking Eligibility
          </p>
          <p className="text-gray-700 text-base  max-w-[500px] mx-auto text-center">
            Checking borrower credentials and validating loan eligibility — this
            won’t take long...
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckingEligibility;
